<div class="chart-card">
  @if (!isLoading) {
    <div class="chart-header">
      <div class="chart-title-section">
        <div class="title-and-trend">
          <h3 class="chart-title">{{ title }}</h3>
          @if (hasData()) {
            <app-graph-trend-icon
              [percentageChange]="percentageChange"
              [formattedChange]="formatPercentChange()"
              [formatValue]="formatValue(totalValue)"
              [isUptrendPositive]="isUptrendPositive()">
            </app-graph-trend-icon>
          }
        </div>
        <span ngbDropdown class="header-controls" [autoClose]="true">
          <button type="button" class="btn dropdown-filter form-control dropdown-toggle"
            id="assetCostFilterDropdown" ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle">{{ (filterLabel === 'Best' ? 'maintenanceDashboard.best' : 'maintenanceDashboard.worst') | transloco }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>
          <div ngbDropdownMenu aria-labelledby="assetCostFilterDropdown">
            <div class="d-flex flex-column">
              <button class="btn btn-outline" (click)="onFilterChange('Best')" ngbDropdownItem>{{ 'maintenanceDashboard.best' | transloco }}</button>
              <button class="btn btn-outline" (click)="onFilterChange('Worst')" ngbDropdownItem>{{ 'maintenanceDashboard.worst' | transloco }}</button>
            </div>
          </div>
        </span>
      </div>
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="noDataTitle"></ng-container>
  }

  <ng-template #noDataTitle>
    <div class="chart-header">
      <div class="chart-title-section">
        <h3 class="chart-title">{{ title }}</h3>
      </div>
    </div>
  </ng-template>

  <div class="chart-body">
    @defer (on timer(100ms)) {
      @if (!isLoading && hasData()) {
        <div class="chart-content">
          <div class="chart-container">
            <app-donut-chart
              [data]="data"
              [innerRadiusRatio]="0.5"
              [variableArcWidths]="true"
              [arcReductionPercent]="0.2"
              [width]="175"
              [height]="175"
            />
          </div>
          <div class="chart-legend-list">
            <div class="legend-item" *ngFor="let asset of data">
              <div class="legend-info">
                <span class="legend-dot" [style.background-color]="asset.color"></span>
                <span class="legend-label" [title]="asset.name">{{ asset.name }}</span>
              </div>
              <span class="legend-value">{{ currencySymbol }}{{ asset.value.toLocaleString() }}</span>
            </div>
          </div>
        </div>
      } @else if (!isLoading && !hasData()) {
        <div class="d-flex align-items-center justify-content-center no-data">
          <app-empty-state></app-empty-state>
        </div>
      }
    }
  </div>

  @if (isLoading) {
    <div class="card-loader">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  }
</div>